import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/biler-til-salg")({
  component: BilerTilSalgLayout,
});

function BilerTilSalgLayout() {
  return <Outlet />;
}
